export default "__VITE_ASSET__DpUMlrsp__"